export type BorderRadius = {
  'Radius NONE': number
  'Radius XXS': number
  'Radius XS': number
  'Radius SM': number
  'Radius MD': number
  'Radius LG': number
  'Radius XL': number
  'Radius 2XL': number
  'Radius 3XL': number
  'Radius FULL': number
}

export const borderRadius = {
  Default: {
    'Radius NONE': 0,
    'Radius XXS': 4,
    'Radius XS': 8,
    'Radius SM': 10,
    'Radius MD': 12,
    'Radius LG': 16,
    'Radius XL': 24,
    'Radius 2XL': 32,
    'Radius 3XL': 40,
    'Radius FULL': 1000,
  },
  Large: {
    'Radius NONE': 0,
    'Radius XXS': 6,
    'Radius XS': 10,
    'Radius SM': 12,
    'Radius MD': 16,
    'Radius LG': 20,
    'Radius XL': 28,
    'Radius 2XL': 36,
    'Radius 3XL': 48,
    'Radius FULL': 1000,
  },
  'X Large': {
    'Radius NONE': 0,
    'Radius XXS': 8,
    'Radius XS': 12,
    'Radius SM': 14,
    'Radius MD': 18,
    'Radius LG': 24,
    'Radius XL': 32,
    'Radius 2XL': 40,
    'Radius 3XL': 56,
    'Radius FULL': 1000,
  },
} satisfies Record<string, BorderRadius>

export type DynamicSizeVariables = {
  'Height/Button': string
  'Height/Button Medium': string
  'Height/Choice card': string
  'Typography/H1': string
  'Typography/H2': string
  'Typography/H3': string
  'Typography/H4': string
  'Typography/T1': string
  'Typography/T2': string
  'Typography/T3': string
  'Typography/T4': string
  'Typography/T5': string
}

export type DynamicSize = {
  smallMobile: DynamicSizeVariables
  mobile: DynamicSizeVariables
  desktop: DynamicSizeVariables
}

export const dynamicSizeVariant = {
  'Large Mobile': {
    'Height/Button': '3.5rem',
    'Height/Button Medium': '2.5rem',
    'Height/Choice card': '4.25rem',
    'Typography/H1': '2.125rem',
    'Typography/H2': '1.875rem',
    'Typography/H3': '1.625rem',
    'Typography/H4': '1.375rem',
    'Typography/T1': '1.25rem',
    'Typography/T2': '1.125rem',
    'Typography/T3': '1rem',
    'Typography/T4': '0.875rem',
    'Typography/T5': '0.75rem',
  },
  'Large Desktop': {
    'Height/Button': '3.5rem',
    'Height/Button Medium': '2.5rem',
    'Height/Choice card': '4.25rem',
    'Typography/H1': '2.375rem',
    'Typography/H2': '2.125rem',
    'Typography/H3': '1.875rem',
    'Typography/H4': '1.625rem',
    'Typography/T1': '1.25rem',
    'Typography/T2': '1.125rem',
    'Typography/T3': '1rem',
    'Typography/T4': '0.875rem',
    'Typography/T5': '0.75rem',
  },
  'Small Mobile': {
    'Height/Button': '3rem',
    'Height/Button Medium': '2.25rem',
    'Height/Choice card': '4rem',
    'Typography/H1': '2rem',
    'Typography/H2': '1.75rem',
    'Typography/H3': '1.5rem',
    'Typography/H4': '1.25rem',
    'Typography/T1': '1.125rem',
    'Typography/T2': '1rem',
    'Typography/T3': '0.875rem',
    'Typography/T4': '0.75rem',
    'Typography/T5': '0.625rem',
  },
  'Small Desktop': {
    'Height/Button': '3rem',
    'Height/Button Medium': '2.25rem',
    'Height/Choice card': '4rem',
    'Typography/H1': '2.25rem',
    'Typography/H2': '2rem',
    'Typography/H3': '1.75rem',
    'Typography/H4': '1.5rem',
    'Typography/T1': '1.125rem',
    'Typography/T2': '1rem',
    'Typography/T3': '0.875rem',
    'Typography/T4': '0.75rem',
    'Typography/T5': '0.625rem',
  },
  'X Large Mobile': {
    'Height/Button': '4rem',
    'Height/Button Medium': '3rem',
    'Height/Choice card': '4.5rem',
    'Typography/H1': '2.25rem',
    'Typography/H2': '2rem',
    'Typography/H3': '1.75rem',
    'Typography/H4': '1.5rem',
    'Typography/T1': '1.375rem',
    'Typography/T2': '1.25rem',
    'Typography/T3': '1.125rem',
    'Typography/T4': '1rem',
    'Typography/T5': '0.875rem',
  },
  'X Large Desktop': {
    'Height/Button': '4rem',
    'Height/Button Medium': '3rem',
    'Height/Choice card': '4.5rem',
    'Typography/H1': '2.5rem',
    'Typography/H2': '2.25rem',
    'Typography/H3': '2rem',
    'Typography/H4': '1.75rem',
    'Typography/T1': '1.375rem',
    'Typography/T2': '1.25rem',
    'Typography/T3': '1.125rem',
    'Typography/T4': '1rem',
    'Typography/T5': '0.875rem',
  },
} satisfies Record<string, DynamicSizeVariables>

export const defaultDynamicSizes = {
  smallMobile: dynamicSizeVariant['Small Mobile'],
  mobile: dynamicSizeVariant['Small Mobile'],
  desktop: dynamicSizeVariant['Small Desktop'],
} satisfies DynamicSize
